module.exports = __webpack_public_path__ + "static/media/initial_circle.d3a9a619.svg";